module.exports = __webpack_public_path__ + "static/img/aiAbility-img2.310a55a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keyFeatures/aiAbility-img2.png
// module id = 0849
// module chunks = 0